export default "__VITE_ASSET__CP__GOb0__"